import {Component, Input, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";

@Component({
  selector: "app-pie-chart-2",
  templateUrl: "./pie-chart-2.component.html",
  styleUrls: ["./pie-chart-2.component.scss"],
  standalone: true,
  imports: [CommonModule]
})
export class PieChart2Component implements OnInit {
  @Input() centerText: number;
  @Input() yellowStroke: boolean = false;

  lastOffSet: number = 0;
  lastOffSet2: number = 0;
  circleLength: number = 360.593;
  circleLength2: number = 310.327;

  constructor() {}

  ngOnInit() {
  }

  resetOffSet() {
    this.lastOffSet = 0;
  }

  resetOffSet2() {
    this.lastOffSet2 = 0;
  }

  dashArray(percent: number,radius) {
    let length = 2 * Math.PI * radius;
    let x = length * Math.min(100, percent) / 100;
    let y = length - x;
    return [x, y];
  }

  strokeDashArray(item: number, radius) {
    return this.dashArray(item,radius).join(" ");
  }

  strokeDashOffSet(item: number, center): number {
    let h;
    let dashArray = this.dashArray(item, center);
    h = (center ? this.circleLength2 : this.circleLength) / 4;
    let res = h - dashArray[1] + (center ? this.lastOffSet : this.lastOffSet2);
    if (center) {
      this.lastOffSet += dashArray[0];
    } else {
      this.lastOffSet2 += dashArray[0];
    }
    return res;
  }

  getRoundNumber(val: number) {
    return Math.round(val);
  }
}
